import { render, staticRenderFns } from "./YearSelector.vue?vue&type=template&id=1937ed7e&scoped=true&"
import script from "./YearSelector.vue?vue&type=script&lang=js&"
export * from "./YearSelector.vue?vue&type=script&lang=js&"
import style0 from "./YearSelector.vue?vue&type=style&index=0&id=1937ed7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937ed7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardText,VChip,VSelect})
